import { ReactNode } from 'react'
import { Card, TypographyProps } from '@mui/material'

type OutlinedCardProps = {
  children: ReactNode
  color?: TypographyProps['color']
}

export default function OutlinedCard({
  children,
  color = 'secondary',
}: OutlinedCardProps) {
  return (
    <Card
      variant="outlined"
      sx={{
        py: 1,
        px: 2,
        borderColor: color,
        borderRadius: 3,
        background: 'transparent',
        transition: 'all 0.25s',
        color,
      }}
    >
      {children}
    </Card>
  )
}
